import React from 'react';

import {TodayTomorrowButtons} from '../';
import DateRangePicker from 'components/DateRangePicker';
import ButtonDropdown from 'components/ButtonDropdown';

import './styles.css';

const FiltersSection = ({
  filter,
  showToday,
  showTomorrow,
  showDateRange,
  exportFrontDesk,
  frontDeskExporting
}) => {
  return (
    <div className="FiltersSection">
      <div className="filters">
        <TodayTomorrowButtons
          isToday={filter.value === 'today'}
          isTomorrow={filter.value === 'tomorrow'}
          showTodays={showToday}
          showTomorrows={showTomorrow}
        />
        <DateRangePicker
          start={filter.dateFrom}
          end={filter.dateTo}
          handleBothDatesChange={showDateRange}
          handleBothDatesClear={showToday}
          disableBeforeToday={true}
        />
      </div>
      <ButtonDropdown
        small
        title="Export Options"
        className="exportOptionsButton"
        menuPosition={ButtonDropdown.MENU_POSITION_BOTTOM_LEFT}
        isLoading={frontDeskExporting}>
        <ButtonDropdown.Option onClick={exportFrontDesk}>
          Export Front Desk
        </ButtonDropdown.Option>
      </ButtonDropdown>
    </div>
  );
};

export default FiltersSection;
